import type { AxiosResponse } from "axios";
import type { ApiResponse } from "@/types/apis";

export class CustomApiError extends Error {
  response: AxiosResponse<ApiResponse>; // 存储完整的响应数据
  constructor(message: string, response: AxiosResponse<ApiResponse>) {
    super(message);
    this.name = "CustomApiError";
    this.response = response;
  }
}
